import axios from '../wmsAxios'

/*
 * 事务日志模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tranLog/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tranLog/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tranLog/findPage',
        method: 'post',
        data
    })
}

// 根据ID查询
export const findById = (id) => {
    return axios({
        url: '/tranLog/findById?id=' + id,
        method: 'get'
    })
}

// 获取事务类型列表
export const getTranTypes = (data) => {
    return axios({
        url: '/tranLog/getTranTypes',
        method: 'post',
        data
    })
} 

// 查询入库操作日志
export const getInboundOperationLog = (data) => {
    return axios({
        url: '/tranLog/getInboundOperationLog',
        method: 'post',
        data
    })
}

// 查询出库操作日志
export const getOutboundOperationLog = (data) => {
    return axios({
        url: '/tranLog/getOutboundOperationLog',
        method: 'post',
        data
    })
}

// 查询库内操作日志
export const getInventoryOperationLog = (data) => {
    return axios({
        url: '/tranLog/getInventoryOperationLog',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/tTranLog.js